import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tun-skip-icon',
  templateUrl: './skip-icon.component.html',
  styleUrls: ['./skip-icon.component.scss']
})
export class SkipIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
